import enumFactory from "@/util/enumFactory";

export default enumFactory.createEnum({

    NEWS_INDEX: {
        code: 1,
        title: '资讯列表页'
    },
    NEWS_DETAIL: {
        code: 2,
        title: '资讯详情页'
    },
    DATUM_INDEX: {
        code: 5,
        title: '资料主页'
    },
    ATLAS_DETAIL: {
        code: 12,
        title: '图集详情页'
    },
    HOME_OPEN_WINDOW: {
        code: 17,
        title: '首页弹窗'
    },
    DATUM_DETAIL: {
        code: 20,
        title: '资料详情'
    },
    HOME_BANNER_TOP: {
        code: 21,
        title: '首页轮播图'
    },
    // POPULARIZE_EDU: {
    //     code: 22,
    //     title: '推广首页-学历'
    // },
    VIP_INDEX: {
        code: 22,
        title: '会员主页列表'
    },
    POPULARIZE_COMP: {
        code: 23,
        title: '推广首页-合作'
    },
    POPULARIZE_EDU_DETAIL: {
        code: 24,
        title: '推广学历详情'
    },
    INDEX_TOPIC: {
        code: 26,
        title: '首页主题包'
    },
    INDEX_PACKAGE: {
        code: 27,
        title: '首页套餐包'
    },
    INTEGRAL_PAGE: {
        code: 29,
        title: '积分页面'
    },
    VIP_PAGE: {
        code: 30,
        title: '会员页'
    },

    VIP_PAGE_TOP: {
        code: 31,
        title: '会员页顶部'
    },
    VIP_PAGE_BOTTOM: {
        code: 32,
        title: '会员页底部'
    },
    VIP_PAGE_PAY: {
        code: 33,
        title: '会员支付成功页'
    },
    COURSE_LIST_PAGE: {
        code: 34,
        title: '课程列表页'
    },
    ATLAS_LIST_PAGE: {
        code: 35,
        title: '图集列表'
    },
    NINE_POINT_NINE_COURSE_PAGE: {
        code: 36,
        title: '9.9元好课'
    },
    VOICE_DETAIL_PAGE: {
        code: 37,
        title: '听书详情页'
    },
    FREE_VOD_PAGE: {
        code: 38,
        title: '免费畅学7节课'
    },
    TOP_COURSE_PAGE: {
        code: 39,
        title: 'TOP主题详情页'
    },
    VIP_EXALTED_PAGE: {
        code: 40,
        title: 'VIP 免费尊享页'
    },

    STAR_COURSE_PAGE: {
        code: 41,
        title: '星级专题包详情页'
    },
    ADVANCE_GO_COURSE_PAGE: {
        code: 42,
        title: '提前购列表页'
    },
    LEARN_LIST_PAGE: {
        code: 43,
        title: '学习清单页'
    },
    SEARCH_PAGE: {
        code: 44,
        title: '搜索页'
    },
    LISTEN_INDEX: {
        code: 46,
        title: '听书首页'
    },
    COURSE_LIST_SVIP_PAGE: {
        code: 47,
        title: '课程列表页-SVIP状态'
    },
    COURSE_LIST_PAGE_NO_OPEN_SVIP: {
        code: 48,
        title: '课程列表页-未开通SVIP'
    },
    COURSE_LIST_PAGE_VIP_EXPIRED: {
        code: 49,
        title: '课程列表页-VIP已过期'
    },
    COURSE_LIST_PAGE_NO_OPEN_VIP: {
        code: 50,
        title: '课程列表页-从未开通VIP'
    },
    SPECIAL_ALBUM: {
        code: 51,
        title: '特邀专辑页'
    },
    SIGN_PAGE: {
        code: 52,
        title: '签到页'
    },
    CHOICENESS_DATUM_PAGE: {
        code: 54,
        title: '精选资料页'
    },
    CHOICENESS_COURSE_LIST: {
        code: 55,
        title: '精品课程列表页'
    },
    COURSE_OF_FAMOUS_TEACHER: {
        code: 56,
        title: '名师名课列表页'
    },
    SPECIAL_TRAINING: {
        code: 57,
        title: '特训营列表页'
    },
    HUMAN_RESOURCES_RESUME_LIST: {
        code: 58,
        title: '师讯人才简历列表页（招幼师）'
    },
    DOWNLOADING_COUNT_RECHARGE_SUCCESS: {
        code: 59,
        title: '下载次数充值成功页面'
    },
    // 今日、本月、下月，统一用 COURSE_LIST_PAGE
    // TODAY_VOD_COURSE_LIST_PAGE: {
    //     code: 60,
    //     title: '今日上新课程列表页'
    // },
    // MONTHLY_VOD_COURSE_LIST_PAGE: {
    //     code: 61,
    //     title: '本月必学课程列表页'
    // },
    // NEXT_MONTH_VOD_COURSE_LIST_PAGE: {
    //     code: 62,
    //     title: '下月必备课程列表页'
    // },
    DISCOVER_INDEX: {
        code: 63,
        title: '发现页列表'
    },
    TEACHER_LIST_PAGE: {
        code: 64,
        title: '老师列表'
    },
    DISCOVER_PAGE: {
        code: 65,
        title: '发现页'
    },
    POSTER_MINIAPP_POSTER_MODULE: {
        code: 66,
        title: '海报小程序的海报模块'
    },
    COURSEWARE_MINIAPP_POSTER_MODULE: {
        code: 67,
        title: '课件小程序的海报模块'
    },
    RECRUIT_WEBAPP_POSTER_MODULE: {
        code: 68,
        title: '招聘web应用的海报模块'
    },
    UNDERLINE_COURSE_INDEX: {
        code: 69,
        title: '线下课程列表'
    },
    AUTHENTICATED_COURSE_PAGE: {
        code: 70,
        title: '认证课程列表'
    },
    FREE_COURSE_PAGE: {
        code: 71,
        title: '免费课程列表'
    },
    SPECIAL_SUBJECT_LIST: {
        code: 72,
        title: '专题课列表'
        // 定位就是名师名课
    },
    NEW_PEOPLE_GIFT_PAGE: {
        code: 73,
        title: '新人福利页面'
    },
    COURSE_DETAIL_VIDEO: {
        code: 74,
        title: '课程页视频广告'
    },
    HOME_FREE_LEARN: {
        code: 75,
        title: '首页-免费学'
    },
    SHOP_GOODS_LIST: {
        code: 76,
        title: '实物售卖列表页'
    },
    DISTRIBUTOR_WITHDRAW_REQUEST: {
        code: 77,
        title: '分销提现申请'
    },
    HOME_POSITION_1 : {
        code: 80,
        title: '首页位置1'
    },
    HOME_POSITION_2 : {
        code: 81,
        title: '首页位置2'
    },
    TOP_LiST: {
        code: 82,
        title: '主题包列表'
    },
    HOME_SMALL_AD_RIGHT: {
        code: 85,
        title: '首页小广告位置右'
    },

});
